<template>
<!--  <div style="color: #fff;">-->
  <t-dialog header="流程图编辑" v-model:visible="modelShow" width="1500px" :closeOnOverlayClick="false" top="50px" :footer="false">
    <div class="top">
      <div style="margin-left: 60px;line-height: 40px;float:left">G6 Editor</div>
      <div style="margin-left: 100px;float:left;width: 400px;height: 100%">
        <div v-for="item in toolBar" :key="item" style="width: 40px;display: inline-block;cursor: pointer"
             :style="currentLine === item ? {background: '#3f4b5f'}:{}" @click="choiceTool(item)">
          <img style="width: 20px;margin: 10px 10px;" :src="require('@/assets/g6/toolBar/'+item+'.svg')" :alt="item"/>
        </div>
      </div>
      <t-button style="float: right;margin: 10px 10px;" @click="confirm" size="small">完成编辑</t-button>
      <t-button style="float: right;margin: 10px 10px;" @click="copyCurrNode" size="small">复制当前节点</t-button>
    </div>
    <div :style="{height: windowHeight-40+'px'}" style="overflow-y: hidden">
      <div style="width: 80px;height: 100%;float:left;background-color: #49586e">
        <NodesBar @dragStart="dragStart"/>
      </div>
      <div style="height: 100%;float:left;" :style="{width:windowWidth-410+'px'}">
        <div :id="uuid" style="width: 100%;height: 100%;"
             :style="{background: 'url('+require('@/assets/g6/grid.svg')+') repeat'}"
             @dragover="allowDrop" @drop="drop"/>
      </div>
      <div style="width: 260px;height: 100%;float:right;background-color: #49586e;box-shadow: 0 1px 6px #3f4b5f inset;overflow: auto">
        <G6ConfigBar ref="g6Config" @updateItem="updateItem" @delItem="delItem"/>
      </div>
    </div>
  </t-dialog>
</template>

<script>
import G6 from '@antv/g6';
import NodesBar from "@/views/g6eidtor/nodes-bar";
import G6ConfigBar from "./config-bar-g6";
import DefaultElement from "@/views/g6eidtor/default-element";

export default {
  name: "g6-editor",
  components: {G6ConfigBar, NodesBar},
  props:{
    data:Object
  },
  data(){
    return {
      uuid: null,
      modelShow:false,
      windowWidth:1500,
      windowHeight:700,
      graph: null,
      copyDom: null,
      currentNode: null,
      currentLine:'choice',
      toolBar:['choice','line','polyline','quadratic','cubic'],
      designData:{
        canvas:{
          type:'',layout:'custom',rankdir:'TB'
        },
        nodes:[],
        edges:[]
      }
    }
  },
  created() {
    this.uuid = require('uuid').v1();
    this.designData.nodes = this.data.nodes;
    this.designData.edges = this.data.edges;
    // this.windowWidth = document.documentElement.clientWidth
    // this.windowHeight = document.documentElement.clientHeight
  },
  mounted() {
    this.init();
    this.$refs.g6Config.showConfig(0,this.designData.canvas);
  },
  methods:{
    opened(){
      this.modelShow = true
    },
    choiceTool(item){
      this.currentLine = item;
      if(item === 'choice'){
        this.graph.setMode('default')
      }else{
        this.graph.setMode('line');
        this.graph.set('defaultEdge',DefaultElement.edge[item])
      }
    },
    init(){
      const that = this;
      const focusEle = {shadowColor:'#0c91ff', shadowBlur:10}
      const selectedEle = {shadowColor:'#0c91ff', shadowBlur:10,lineWidth: 1}
      const graph = new G6.Graph({
        container: that.uuid,
        width:that.windowWidth-300,
        height:that.windowHeight-40,
        linkCenter: true, // 使边连入节点的中心，设置false会导致矩形元素不能连接上下边，设置true会导致看不见边箭头
        modes: {
          default:['drag-node',{
            type: 'brush-select',
            trigger: 'ctrl'
          },'drag-canvas', 'zoom-canvas'],
          line: ['create-edge','drag-node','drag-canvas', 'zoom-canvas']
        },
        nodeStateStyles: {
          hoverEle: focusEle,
          focusEle:focusEle,
          selected:selectedEle,
        },
        edgeStateStyles: {
          hoverEle: focusEle,
          focusEle: focusEle,
          selected: selectedEle,
        },
        lastEleId:null//标记上一个聚焦的元素
      });

      graph.on('aftercreateedge', (e) => {
        const model = e.edge.getModel();
        let edge = JSON.parse(JSON.stringify(DefaultElement.edge[model.type]));//对象拷贝：避免覆盖之前生成的边的id
        edge.id = model.id;
        // edge.id = require('uuid').v1();
        edge.source=model.source;
        edge.target=model.target;

        that.designData.edges.push(edge);
        graph.updateItem(model.id, JSON.parse(JSON.stringify(edge)), false)//对象拷贝：避免G6渲染添加完整配置污染数据

        // that.renderCanvas()
        // 平行边处理
        // const edges = graph.save().edges;
        // G6.Util.processParallelEdges(edges,10,'quadratic',model.type,'loop');
        // graph.refresh();
      });

      graph.on('node:mouseenter', (evt) => {
        const { item } = evt;
        if (item.getModel().type !== 'image') {//避免图片刷新
          graph.setItemState(item, 'hoverEle', true);
        }
      });
      graph.on('node:mouseleave', (evt) => {
        const { item } = evt;
        if (item.getModel().type !== 'image'){//避免图片刷新
          graph.setItemState(item, 'hoverEle', false);
        }
      });
      graph.on('node:click', (evt) => {
        const { item } = evt;
        that.clearLastItemState();
        const model = item.getModel();
        graph.setItemState(item, 'focusEle', true);
        let index = that.designData.nodes.findIndex((ele)=>{
          return ele.id === model.id
        });
        that.showConfig(1,index);
        that.lastEleId = model.id;
      });
      graph.on('node:dragend', (evt) => {
        const { item } = evt;
        that.clearLastItemState();
        const model = item.getModel();
        graph.setItemState(item, 'focusEle', true);

        for (let i = 0; i < graph.getNodes().length; i++) {//需要观察是否存在graph.nodes的index和designData.nodes的index不一致情况
          const node = graph.getNodes()[i].getModel();
          that.designData.nodes[i].x = Math.round(node.x);
          that.designData.nodes[i].y = Math.round(node.y);
        }

        let currIndex = that.designData.nodes.findIndex((ele)=>{
          return ele.id === model.id
        });
        that.showConfig(1,currIndex);
        that.lastEleId = model.id;
      });
      graph.on('edge:mouseenter', (evt) => {
        const { item } = evt;
        graph.setItemState(item, 'hoverEle', true);
      });
      graph.on('edge:mouseleave', (evt) => {
        const { item } = evt;
        graph.setItemState(item, 'hoverEle', false);
      });
      graph.on('edge:click', (evt) => {
        const { item } = evt;
        that.clearLastItemState();
        graph.setItemState(item, 'focusEle', true);
        const model = item.getModel();
        let index = that.designData.edges.findIndex((ele)=>{
          return ele.id === model.id
        });

        that.showConfig(2,index);
        that.lastEleId = model.id;
      });
      graph.on('canvas:click', () => {
        that.showConfig(0);
        that.clearLastItemState();
        that.lastEleId = null;
      });
      that.graph = graph;
      that.renderCanvas()
    },
    showConfig(type,eleIndex){//type:0画布,1节点,2连线
      let currentEle;
      if(type === 0){
        currentEle = this.designData.canvas
      }else if(type === 1){
        currentEle = this.designData.nodes[eleIndex]
        this.currentNode = currentEle
      }else{
        currentEle = this.designData.edges[eleIndex]
      }
      this.$refs.g6Config.showConfig(type,currentEle,eleIndex);
    },
    drop(e) {//从组件栏丢下组件
      const nodeType = e.dataTransfer.getData('nodeType');
      let temp = JSON.parse(JSON.stringify(DefaultElement.node[nodeType]));
      temp.id = require('uuid').v1();
      temp.x = e.offsetX;
      temp.y = e.offsetY;
      this.designData.nodes.push(temp);
      this.graph.read(JSON.parse(JSON.stringify(this.designData)));//对象拷贝：避免G6渲染添加完整配置污染数据
      this.showConfig(1,this.designData.nodes.length-1);
    },
    allowDrop(e) {e.preventDefault()},
    dragStart(copyDom) {//从组件栏拿起组件
      this.copyDom = copyDom;
      copyDom.draggable = false;
    },
    renderCanvas(){
      console.log('画布渲染，待优化')
      this.graph.data(JSON.parse(JSON.stringify(this.designData)));
      this.graph.render();
    },
    updateItem(newItem){
      let parse = JSON.parse(JSON.stringify(newItem));
      this.graph.updateItem(newItem.id, parse, false)//对象拷贝：避免G6渲染添加完整配置污染数据
      this.graph.refreshItem(parse.id);
    },
    delItem(eleType,eleIndex,ele){
      const that = this;
      if(eleType === 2){
        that.designData.edges.splice(eleIndex, 1);
        that.graph.removeItem(ele.id)
      }else if(eleType === 1){
        let i = that.designData.edges.length;
        while(i--) {//删除连线
          const item = that.designData.edges[i]
          if(item.source === ele.id || item.target === ele.id){
            that.graph.removeItem(item.id);
            that.designData.edges.splice(i, 1);
          }
        }
        //删除节点
        that.designData.nodes.splice(eleIndex, 1);
        that.graph.removeItem(ele.id)
      }
      this.lastEleId = null;
    },
    clearLastItemState(){
      if(this.lastEleId){
        this.graph.clearItemStates(this.lastEleId);
      }
    },
    copyCurrNode(){
      if(!this.currentNode) return;
      let temp = JSON.parse(JSON.stringify(this.currentNode));
      temp.id = require('uuid').v1();
      temp.x += 20;
      temp.y += 10;
      this.designData.nodes.push(temp);
      this.graph.read(JSON.parse(JSON.stringify(this.designData)));//对象拷贝：避免G6渲染添加完整配置污染数据
      this.showConfig(1,this.designData.nodes.length-1);
    },
    confirm(){
      this.$emit('confirm',this.designData)
      this.modelShow = false;
    },
  }
}
</script>

<style scoped>
.top {background: #49586e;height: 40px;overflow: hidden;font-size: 18px;}
</style>
